<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-6.5,782.5h2v1l-4,4h-1v-2L-6.5,782.5L-6.5,782.5z M5.5,782.5h2l3,3v2h-1l-4-4V782.5L5.5,782.5z M0.5,785.5
	c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5S-3,790.93-3,789S-1.43,785.5,0.5,785.5L0.5,785.5z M-4,793h1.15
	c0.63,0.7,1.45,1.17,2.35,1.38v2.12l1,1l1-1v-2.12c0.9-0.21,1.72-0.68,2.35-1.38H5v1.1c0.45,0.24,0.93,0.52,1.5,0.9
	c0.11,0.45,0.22,0.79,0.33,1.18L0.5,799.5l-6.33-3.32c0.11-0.39,0.22-0.73,0.33-1.18c0.57-0.38,1.05-0.66,1.5-0.9V793L-4,793z
	 M-9.5,797.5h1l4,4v1h-2l-3-3V797.5L-9.5,797.5z M9.5,797.5h1v2l-3,3h-2v-1L9.5,797.5L9.5,797.5z"/>
</svg>

</template>